import React, { useRef, useState, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar, Doughnut, Pie } from 'react-chartjs-2';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { setDynamicModalObj } from '../../store/board.actions';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export function Taskavancesgrafic({ board, dynamicModalObj }) {
  const elModalBtn = useRef();
  const [chartType, setChartType] = useState('bar');
  const [groupProgressData, setGroupProgressData] = useState([]);

  // Calcula el progreso para cada grupo
  useEffect(() => {
    if (board && board.length > 0) {
      const progressData = board.map((grupos) => calculateProgressForActivities(grupos));
      setGroupProgressData(progressData);
    }
  }, [board]);

  // Función para calcular el progreso para las actividades
  function calculateProgressForActivities(group) {
    const totalProgress = group.actividades.reduce((acc, actividad) => {
      const meta = parseFloat(actividad.meta) || 0; // Si es NaN, convierte a 0
      const ejecucion = parseFloat(actividad.ejecucion) || 0; // Si es NaN, convierte a 0
      let progress = calculateProgress(meta, ejecucion);
      if (progress > 100) progress = 100; // Limita el progreso a 100
      return acc + progress;
    }, 0);
    const averageProgress = group.actividades.length > 0 
        ? (totalProgress / group.actividades.length).toFixed(2) // Mantiene 2 dígitos después del punto
        : 0; // Si no hay actividades, el promedio es 0
    return averageProgress;
  }

  // Reutilizamos tu función calculateProgress con manejo de valores nulos
  const calculateProgress = (meta, ejecucion) => {
    if (!meta || meta === 0) return 0;
    return Math.round((ejecucion / meta) * 100);
  };

  // Aquí calculamos tanto el progreso logrado como el faltante
  const data = {
    labels: getLabelTitles(),
    datasets: [
      {
        label: 'Progreso alcanzado',
        data: groupProgressData, // Datos de progreso alcanzado
        backgroundColor: '#00c875', // Color verde para el progreso alcanzado
        borderColor: '#00c875',
        borderWidth: 1,
      },
      {
        label: 'Progreso restante',
        data: groupProgressData.map(progress => 100 - progress), // Progreso restante (100 - progreso alcanzado)
        backgroundColor: '#ffc900', // Color rojo para el progreso restante
        borderColor: '#ffc900',
        borderWidth: 1,
      },
    ],
  };

  function getLabelTitles() {
    // Extrae los nombres de los grupos
    return board.map((group) => group.nombre_grupo);
  }

  function onToggleTypeModal() {
    const isOpen =
      dynamicModalObj.chartType === 'label' && dynamicModalObj?.type === 'chart-type'
        ? !dynamicModalObj.isOpen
        : true;
    const { x, y } = elModalBtn.current.getClientRects()[0];
    setDynamicModalObj({
      isOpen,
      pos: { x: x - 110, y: y + 20 },
      type: 'chart-type',
      chartType: 'label',
      setChartType,
    });
  }

  function getChart(chartType) {
    switch (chartType) {
      case 'pie':
        return <Pie data={data} />;
      case 'bar':
        return <Bar data={data} />;
      case 'doughnut':
        return <Doughnut data={data} />;
      default:
        return null;
    }
  }

  return (
    <section className="label-chart">
      <div className="chart-header">
        <div className="header-content">
          <h2>Progreso de Actividades por Grupo</h2>
          <span className="icon-container" ref={elModalBtn} onClick={onToggleTypeModal}>
            <BiDotsHorizontalRounded />
          </span>
        </div>
      </div>
      <div className="chart-content">{getChart(chartType)}</div>
    </section>
  );
}
